import { HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../common-services/response-container';
import { RunOnHoldProjectReleaseDTO } from './run-onhold_releaseDTO';

@Injectable({
  providedIn: 'root'
})
export class RunplanOnholdprojectService {

  defaultTimeout = 600000;

  constructor(private http: HttpClient) { }

  getListOfOnholdProject(labId: string): Observable<any> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/onHoldProject/list";
      let requestParam = new HttpParams().set('lab', labId);
      const options = url ? { params: requestParam } : {};
      return this.http.put<any>(url, {}, options).pipe(timeout(environment.defaultTimeout));
  }

  

  setprojectReleaseFlagged(releaseFlaggedObj: RunOnHoldProjectReleaseDTO) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/onHoldProject/release";
    return this.http.patch<BBResponseContainer>(url, releaseFlaggedObj).pipe(timeout(environment.defaultTimeout), tap(event => error => {
      error.url = url;
    }));
  }

}
